import { Component, HostBinding, model, output } from '@angular/core';
import { CHART_TYPES } from '@constants/payloads';
import { ChartType } from 'ng-apexcharts';

@Component({
  selector: 'nem-chart-toolbar',
  templateUrl: './nem-chart-toolbar.comp.html',
  standalone: false
})
export class NemChartToolbarComponent {
  @HostBinding() class = 'flex items-center gap-1';

  chartTypeValue = model<ChartType | null>(null);

  toggleTableViewChange = output<boolean>();
  exportToCSVChange = output<boolean>();
  dialogVisibleChange = output<boolean>();
  focusModeChange = output<boolean>();

  chartTypeOptions = CHART_TYPES;
}
